import { render, staticRenderFns } from "./ReportPerTable.vue?vue&type=template&id=75e0e1d4&scoped=true&"
import script from "./ReportPerTable.vue?vue&type=script&lang=ts&"
export * from "./ReportPerTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPerTable.vue?vue&type=style&index=0&id=75e0e1d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e0e1d4",
  null
  
)

export default component.exports